import "./Forbidden.scss";
import forbidden from "./images/forbidden@2x.png";
import { useTranslation } from "react-i18next";

export const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <div className="forbidden-page">
      <div className="text-container">
        <p className="header">{t("permission.none")}</p>
        <p className="subtext">{t("permission.description")}</p>
      </div>
      <div className="image-container">
        <img src={forbidden} alt="forbidden" />
      </div>
    </div>
  );
};

export default Forbidden;
